import { styleOverrides } from "./styleOverrides";

const MuiCheckbox = {
  styleOverrides,
};

export { MuiCheckbox };
